import { SaveResponsable } from '../../shared/saveResponsable';

export interface CreateResponsablePageInterface {}

const CreateResponsablePage: React.FC<CreateResponsablePageInterface> = () => {
  return <SaveResponsable titlePage="Crear Responsable" />;
};

export default CreateResponsablePage;
